export default __webpack_public_path__ + "static/media/overview-skewed.a4ac37b6.png";